import moment from 'moment';

import {
  GroupedByDate
} from '../types';

export const getGroupedStorySnippets = <T extends { takenAt: string }>(
  snippets: Array<T>,
  todayDate: Date
): GroupedByDate<T> => {
  const result: GroupedByDate<T> = {
    today: [],
    yesterday: [],
    thisWeek: [],
    lastWeek: [],
    thisMonth: [],
    lastMonth: [],
    lastThreeMonths: [],
    lastSixMonths: []
  };

  return snippets.reduce((acc, snippet) => {
    const date = moment(snippet.takenAt);
    const today = moment(todayDate);
    const diff = today.diff(date, 'days');
    const lastWeek = today.clone().subtract(1, 'week').startOf('week');
    const lastMonth = today.clone().subtract(1, 'month').startOf('month');
    const lastThreeMonths = today.clone().subtract(3, 'month').startOf('month');

    if (diff === 0) {
      acc.today.push(snippet);
    } else if (diff === 1) {
      acc.yesterday.push(snippet);
    } else if (date.isSame(today, 'week')) {
      acc.thisWeek.push(snippet);
    } else if (date.isSame(lastWeek, 'week')) {
      acc.lastWeek.push(snippet);
    } else if (date.isSame(today, 'month')) {
      acc.thisMonth.push(snippet);
    } else if (date.isSame(lastMonth, 'month')) {
      acc.lastMonth.push(snippet);
    } else if (date.isBetween(lastThreeMonths, lastMonth) || date.isSame(lastThreeMonths)) {
      acc.lastThreeMonths.push(snippet);
    } else {
      acc.lastSixMonths.push(snippet);
    }

    return acc;
  }, result);
};
